<template>
  <Category
    cate-name="new-face"
    category-name="新人賞"
    category-intro="2020年に創刊されたメルマガの中から「いちばん読みたい・読んでもらいたいメルマガ」に輝いた新人賞5誌を発表いたします。"
  />
</template>

<script>
import Category from '@/components/Category.vue'
export default {
  components: {
    Category
  }
}
</script>

<style scoped></style>
